
<div class="select_pricing_plan-component" *ngIf="currentRoute != '/setting'">
	<h1 i18n="@@plan.select_your_plan">Select Your Plan</h1>
	<div class="choose_features-block">
		<h3 i18n="@@plan.which_features_do_you_need">Which features do you need:</h3>
	</div>
</div>

<div class="select_pricing_plan-component mt-4" *ngIf="userInfo">

	<div class="tab-container">
		<div class="tabs">
			<button class="tab-button" [class.active]="currentTab === 'invoicing'" (click)="switchTab('invoicing')">
				{{ planNameAsPerVersion('invoicing') }}
			</button>
			<button class="tab-button" *ngIf="userInfo?.business_type == 'food_beverage_ordering'" [class.active]="currentTab === 'onlineOrdering'" (click)="switchTab('onlineOrdering')">
				{{ planNameAsPerVersion('onlineOrdering') }}
			</button>
			<button class="tab-button" *ngIf="userInfo?.business_type != 'food_beverage_ordering'" [class.active]="currentTab === 'onlineStore'" (click)="switchTab('onlineStore')">
				{{ planNameAsPerVersion('onlineStore') }}
			</button>
			<button class="tab-button" [class.active]="currentTab === 'completeSolution'" (click)="switchTab('completeSolution')">
				{{ planNameAsPerVersion('completeSolution') }}
			</button>
			<div class="tab-indicator" [style.left]="tabIndicatorPosition"></div>
		</div>
	</div>

	<div class="tab-content">
		<div class="select-pages_tabs">
			<ul class="tabs_content">
				<li class="tab_item" [class.active]="activeTab == 'yearly'" (click)="tabChange('yearly')">
					<ng-container i18n="@@plan.yearly">Annual billing</ng-container>
					<ng-container i18n="@@plan.discount_off"> ({{ discountPer }}% off)</ng-container>
				</li>
				<li class="tab_item" [class.active]="activeTab == 'monthly'" (click)="tabChange('monthly')">
					<ng-container i18n="@@plan.monthly">Monthly billing</ng-container>
				</li>
			</ul>
		</div>

		<div class="select-pages_tabs_content">
			<div class="pricing_plans_cards_container">
				<div *ngIf="currentTab === 'invoicing'" class="pricing_plans_card">
					<div class="pricing_plans_card-header">
						<span class="plan-name" i18n="@@plan.invoice_basic">Invoice Basic</span>
						<span class="team-size" i18n="@@plan.one_team_member">1 team member</span>
					</div>
					<div class="pricing_plans_card-body">
						<div class="pricing_plans_card-body--header">
							<div *ngIf="activeTab == 'yearly'" class="card_price_block">
								<ng-container *ngIf="tempPlans?.monthly['invoice-basic']?.amount ; else noPrice">
									<div class="card_price_year">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['invoice-basic'].amount }}</span>
										<span i18n="@@plan.per_year">per year</span>
									</div>
									<div class="card_price_month">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-basic'].amount }}</span>
										<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['invoice-basic'].amount) }}</span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
								</ng-container>
								<ng-template  #noPrice>
									<span class="spinner-grow text-muted"></span>
								</ng-template>
							</div>

							<div *ngIf="activeTab == 'monthly'" class="card_price_block">
								<div class="card_price_year" *ngIf="tempPlans?.monthly['invoice-basic']?.amount ; else noPrice">
									<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-basic'].amount }}</span>
									<span i18n="@@plan.per_month">per month</span>
								</div>
								<ng-template  #noPrice>
									<span class="spinner-grow text-muted"></span>
								</ng-template>
							</div>

							<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
								<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
							</span>
						</div>
						<ul class="pricing_plans_card-body--body">
							<!-- <li *ngIf="activeTab == 'yearly'">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round"/>
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									Create unlimited invoices
							</li>
							<li *ngIf="activeTab == 'monthly'">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round"/>
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									10 invoices per month
							</li> -->
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.ten_invoices_per_month">10 invoices per month</ng-container>
							</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.manage_unlimited_clients">Manage unlimited clients</ng-container>
							</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.manage_billing_details">Manage billing details</ng-container>
							</li>
							<li>
								<span>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.accept_online_payments">Accept online payments*</ng-container>
								</span>
								<a href="javascript:;" (click)="openPopup()" i18n="@@plan.learn_mores">Learn more</a>
							</li>
						</ul>
					</div>
					<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
						<subscription-plan-form
							class="w-100"
							[subscriptionBtn]="subscriptionBtn('yearly', 'invoice-basic')"
							[activePlan]="activePlan"
							[planType]="'invoice-basic'"
							[planFrequency]="'yearly'"
							[planAmount]="plans.yearly['invoice-basic'].amount"
							[userDetails]="userInfo"
							(onSubscribePlan)="onSubscribePlan($event)">
						</subscription-plan-form>
					</div>
					<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
						<subscription-plan-form
							class="w-100"
							[subscriptionBtn]="subscriptionBtn('monthly', 'invoice-basic')"
							[activePlan]="activePlan"
							[planType]="'invoice-basic'"
							[planFrequency]="'monthly'"
							[planAmount]="plans.monthly['invoice-basic'].amount"
							[userDetails]="userInfo"
							(onSubscribePlan)="onSubscribePlan($event)">
						</subscription-plan-form>
					</div>
				</div>
				<div *ngIf="currentTab === 'invoicing'" class="pricing_plans_card">
					<div class="pricing_plans_card-header">
						<span class="plan-name" i18n="@@plan.invoice_pro">Invoice Pro</span>
						<span class="team-size" i18n="@@plan.three_team_member">3 team member</span>
					</div>
					<div class="pricing_plans_card-body">
						<div class="pricing_plans_card-body--header">
							<div *ngIf="activeTab == 'yearly'" class="card_price_block">
								<ng-container *ngIf="tempPlans?.yearly['invoice-pro']?.amount ; else noPrice">
									<div class="card_price_year">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['invoice-pro'].amount }}</span>
										<span i18n="@@plan.per_year">per year</span>
									</div>
									<div class="card_price_month">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-pro'].amount }}</span>
										<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['invoice-pro'].amount) }}</span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
								</ng-container>
								<ng-template  #noPrice>
									<span class="spinner-grow text-muted"></span>
								</ng-template>
							</div>
							<div *ngIf="activeTab == 'monthly'" class="card_price_block">
								<div class="card_price_year" *ngIf="tempPlans?.monthly['invoice-pro']?.amount ; else noPrice">
									<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-pro'].amount }}</span>
									<span i18n="@@plan.per_month">per month</span>
								</div>
								<ng-template  #noPrice>
									<span class="spinner-grow text-muted"></span>
								</ng-template>
							</div>
							<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
								<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
							</span>
						</div>
						<ul class="pricing_plans_card-body--body">
							<!-- <li *ngIf="activeTab == 'yearly'">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round"/>
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									Create unlimited invoices
							</li>
							<li *ngIf="activeTab == 'monthly'">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round"/>
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
									100 invoices per month
							</li> -->
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.hundred_invoices_per_month">100 invoices per month</ng-container>
							</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.manage_unlimited_clients">Manage unlimited clients</ng-container>
							</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.manage_billing_details">Manage billing details</ng-container>
							</li>
							<li>
								<span>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.accept_online_payments">Accept online payments*</ng-container>
								</span>
								<a href="javascript:;" (click)="openPopup()" i18n="@@plan.learn_mores">Learn more</a>
							</li>
						</ul>
					</div>
					<!-- <a class="pricing_plans_card-footer" href="">
						<button>Start 30 Day Free Trial</button>
					</a> -->
					<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
						<subscription-plan-form
							class="w-100"
							[subscriptionBtn]="subscriptionBtn('yearly', 'invoice-pro')"
							[activePlan]="activePlan"
							[planType]="'invoice-pro'"
							[planFrequency]="'yearly'"
							[planAmount]="plans.yearly['invoice-pro'].amount"
							[userDetails]="userInfo"
							(onSubscribePlan)="onSubscribePlan($event)">
						</subscription-plan-form>
					</div>
					<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
						<subscription-plan-form
							class="w-100"
							[subscriptionBtn]="subscriptionBtn('monthly', 'invoice-pro')"
							[activePlan]="activePlan"
							[planType]="'invoice-pro'"
							[planFrequency]="'monthly'"
							[planAmount]="plans.monthly['invoice-pro'].amount"
							[userDetails]="userInfo"
							(onSubscribePlan)="onSubscribePlan($event)">
						</subscription-plan-form>
					</div>
				</div>
				<div *ngIf="currentTab === 'invoicing'" class="pricing_plans_card">
					<div class="pricing_plans_card-header">
						<span class="plan-name" i18n="@@plan.invoice_enterprise">Invoice Enterprise</span>
						<span class="team-size" i18n="@@plan.ten_team_member">10 team member</span>
					</div>
					<div class="pricing_plans_card-body">
						<div class="pricing_plans_card-body--header">
							<div *ngIf="activeTab == 'yearly'" class="card_price_block">
								<ng-container *ngIf="tempPlans?.yearly['invoice-enterprise']?.amount ; else noPrice">
									<div class="card_price_year">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['invoice-enterprise'].amount }}</span>
										<span i18n="@@plan.per_year">per year</span>
									</div>
									<div class="card_price_month">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-enterprise'].amount }}</span>
										<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['invoice-enterprise'].amount) }}</span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
								</ng-container>
								<ng-template  #noPrice>
									<span class="spinner-grow text-muted"></span>
								</ng-template>
							</div>
							<div *ngIf="activeTab == 'monthly'" class="card_price_block">
								<div class="card_price_year" *ngIf="tempPlans?.monthly['invoice-enterprise']?.amount ; else noPrice">
									<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-enterprise'].amount }}</span>
									<span i18n="@@plan.per_month">per month</span>
								</div>
								<ng-template  #noPrice>
									<span class="spinner-grow text-muted"></span>
								</ng-template>
							</div>
							<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
								<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
							</span>
						</div>
						<ul class="pricing_plans_card-body--body">
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.create_unlimited_invoices">Create unlimited invoices</ng-container>
							</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.manage_unlimited_clients">Manage unlimited clients</ng-container>
							</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.manage_billing_details">Manage billing details</ng-container>
							</li>
							<li>
								<span>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.accept_online_payments">Accept online payments*</ng-container>
								</span>
								<a href="javascript:;" (click)="openPopup()" i18n="@@plan.learn_mores">Learn more</a>
							</li>
						</ul>
					</div>
					<!-- <a class="pricing_plans_card-footer" href="">
						<button>Start 30 Day Free Trial</button>
					</a> -->
					<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
						<subscription-plan-form
							class="w-100"
							[subscriptionBtn]="subscriptionBtn('yearly', 'invoice-enterprise')"
							[activePlan]="activePlan"
							[planType]="'invoice-enterprise'"
							[planFrequency]="'yearly'"
							[planAmount]="plans.yearly['invoice-enterprise'].amount"
							[userDetails]="userInfo"
							(onSubscribePlan)="onSubscribePlan($event)">
						</subscription-plan-form>
					</div>
					<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
						<subscription-plan-form
							class="w-100"
							[subscriptionBtn]="subscriptionBtn('monthly', 'invoice-enterprise')"
							[activePlan]="activePlan"
							[planType]="'invoice-enterprise'"
							[planFrequency]="'monthly'"
							[planAmount]="plans.monthly['invoice-enterprise'].amount"
							[userDetails]="userInfo"
							(onSubscribePlan)="onSubscribePlan($event)">
						</subscription-plan-form>
					</div>
				</div>

				<ng-container *ngIf="userInfo?.business_type == 'food_beverage_ordering'; else elseOnlineStore">
					<div *ngIf="currentTab === 'onlineOrdering'" class="pricing_plans_card">
						<div class="pricing_plans_card-header">
							<span class="plan-name" i18n="@@plan.online_ordering_basic">Online Ordering Basic</span>
							<span class="team-size" i18n="@@plan.one_team_member">1 team member</span>
						</div>
						<div class="pricing_plans_card-body">
							<div class="pricing_plans_card-body--header">
								<div *ngIf="activeTab == 'yearly'" class="card_price_block">
									<ng-container *ngIf="tempPlans?.yearly['online-ordering-basic']?.amount ; else noPrice">
										<div class="card_price_year">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-ordering-basic'].amount }}</span>
											<span i18n="@@plan.per_year">per year</span>
										</div>
										<div class="card_price_month">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-basic'].amount }}</span>
											<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-ordering-basic'].amount) }}</span>
											<span i18n="@@plan.per_month">per month</span>
										</div>
									</ng-container>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<div *ngIf="activeTab == 'monthly'" class="card_price_block">
									<div class="card_price_year" *ngIf="tempPlans?.monthly['online-ordering-basic']?.amount ; else noPrice">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-basic'].amount }}</span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
									<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
								</span>
							</div>
							<ul class="pricing_plans_card-body--body">
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.add_unlimited_items">Add unlimited items</ng-container>
								</li>
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.pick_up_and_courier_delivery">Pick up and courier delivery</ng-container>
								</li>
								<li>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
										<ng-container i18n="@@plan.accept_payments">Accept payments*</ng-container>
									</span>
									<a href="javascript:;" (click)="openPopup()" i18n="@@plan.learn_mores">Learn more</a>
								</li>
							</ul>
						</div>
						<!-- <a class="pricing_plans_card-footer" href="">
							<button>Start 30 Day Free Trial</button>
						</a> -->
						<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('yearly', 'online-ordering-basic')"
								[activePlan]="activePlan"
								[planType]="'online-ordering-basic'"
								[planFrequency]="'yearly'"
								[planAmount]="plans.yearly['online-ordering-basic'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
						<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('monthly', 'online-ordering-basic')"
								[activePlan]="activePlan"
								[planType]="'online-ordering-basic'"
								[planFrequency]="'monthly'"
								[planAmount]="plans.monthly['online-ordering-basic'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
					</div>
					<div *ngIf="currentTab === 'onlineOrdering'" class="pricing_plans_card">
						<div class="pricing_plans_card-header">
							<span class="plan-name" i18n="@@plan.online_ordering_pro">Online Ordering Pro</span>
							<span class="team-size" i18n="@@plan.three_team_member">3 team member</span>
						</div>
						<div class="pricing_plans_card-body">
							<div class="pricing_plans_card-body--header">
								<div *ngIf="activeTab == 'yearly'" class="card_price_block">
									<ng-container *ngIf="tempPlans?.yearly['online-ordering-pro']?.amount ; else noPrice">
										<div class="card_price_year">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-ordering-pro'].amount }}</span>
											<span i18n="@@plan.per_year">per year</span>
										</div>
										<div class="card_price_month">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-pro'].amount }}</span>
											<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-ordering-pro'].amount) }}</span>
											<span i18n="@@plan.per_month">per month</span>
										</div>
									</ng-container>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<div *ngIf="activeTab == 'monthly'" class="card_price_block">
									<div class="card_price_year" *ngIf="tempPlans?.monthly['online-ordering-pro']?.amount ; else noPrice">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-pro'].amount }}</span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
									<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
								</span>
							</div>
							<ul class="pricing_plans_card-body--body">
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.add_unlimited_items">Add unlimited items</ng-container>
								</li>
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.pick_up_and_courier_delivery">Pick up and courier delivery</ng-container>
								</li>
								<li>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
										<ng-container i18n="@@plan.accept_payments">Accept payments*</ng-container>
									</span>
									<a href="javascript:;" (click)="openPopup()" i18n="@@plan.learn_mores">Learn more</a>
								</li>
							</ul>
						</div>
						<!-- <a class="pricing_plans_card-footer" href="">
							<button>Start 30 Day Free Trial</button>
						</a> -->
						<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('yearly', 'online-ordering-pro')"
								[activePlan]="activePlan"
								[planType]="'online-ordering-pro'"
								[planFrequency]="'yearly'"
								[planAmount]="plans.yearly['online-ordering-pro'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
						<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('monthly', 'online-ordering-pro')"
								[activePlan]="activePlan"
								[planType]="'online-ordering-pro'"
								[planFrequency]="'monthly'"
								[planAmount]="plans.monthly['online-ordering-pro'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
					</div>
					<div *ngIf="currentTab === 'onlineOrdering'" class="pricing_plans_card">
						<div class="pricing_plans_card-header">
							<span class="plan-name" i18n="@@plan.online_ordering_enterprise">Online Ordering Enterprise</span>
							<span class="team-size" i18n="@@plan.ten_team_member">10 team member</span>
						</div>
						<div class="pricing_plans_card-body">
							<div class="pricing_plans_card-body--header">
								<div *ngIf="activeTab == 'yearly'" class="card_price_block">
									<ng-container *ngIf="tempPlans?.yearly['online-ordering-enterprise']?.amount ; else noPrice">
										<div class="card_price_year">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-ordering-enterprise'].amount }} </span>
											<span i18n="@@plan.per_year">per year</span>
										</div>
										<div class="card_price_month">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-enterprise'].amount }} </span>
											<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-ordering-enterprise'].amount) }} </span>
											<span i18n="@@plan.per_month">per month</span>
										</div>
									</ng-container>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<div *ngIf="activeTab == 'monthly'" class="card_price_block">
									<div class="card_price_year" *ngIf="tempPlans?.monthly['online-ordering-enterprise']?.amount ; else noPrice">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-enterprise'].amount }} </span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
									<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
								</span>
							</div>
							<ul class="pricing_plans_card-body--body">
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.add_unlimited_items">Add unlimited items</ng-container>
								</li>
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.pick_up_and_courier_delivery">Pick up and courier delivery</ng-container>
								</li>
								<li>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
										<ng-container i18n="@@plan.accept_payments">Accept payments*</ng-container>
									</span>
									<a href="javascript:;" (click)="openPopup()" i18n="@@plan.learn_mores">Learn more</a>
								</li>
							</ul>
						</div>
						<!-- <a class="pricing_plans_card-footer" href="">
							<button>Start 30 Day Free Trial</button>
						</a> -->
						<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('yearly', 'online-ordering-enterprise')"
								[activePlan]="activePlan"
								[planType]="'online-ordering-enterprise'"
								[planFrequency]="'yearly'"
								[planAmount]="plans.yearly['online-ordering-enterprise'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
						<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('monthly', 'online-ordering-enterprise')"
								[activePlan]="activePlan"
								[planType]="'online-ordering-enterprise'"
								[planFrequency]="'monthly'"
								[planAmount]="plans.monthly['online-ordering-enterprise'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
					</div>
				</ng-container>

				<ng-template #elseOnlineStore>
					<div *ngIf="currentTab === 'onlineStore'" class="pricing_plans_card">
						<div class="pricing_plans_card-header">
							<span class="plan-name" i18n="@@plan.online_store_basic">Online Store Basic</span>
							<span class="team-size" i18n="@@plan.one_team_member">1 team member</span>
						</div>
						<div class="pricing_plans_card-body">
							<div class="pricing_plans_card-body--header">
								<div *ngIf="activeTab == 'yearly'" class="card_price_block">
									<ng-container *ngIf="tempPlans?.yearly['online-store-basic']?.amount ; else noPrice">
										<div class="card_price_year">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-store-basic'].amount }}</span>
											<span i18n="@@plan.per_year">per year</span>
										</div>
										<div class="card_price_month">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-basic'].amount }}</span>
											<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-store-basic'].amount) }}</span>
											<span i18n="@@plan.per_month">per month</span>
										</div>
									</ng-container>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<div *ngIf="activeTab == 'monthly'" class="card_price_block">
									<div class="card_price_year" *ngIf="tempPlans?.monthly['online-store-basic']?.amount ; else noPrice">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-basic'].amount }}</span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
									<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
								</span>
							</div>
							<ul class="pricing_plans_card-body--body">
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.add_unlimited_items">Add unlimited items</ng-container>
								</li>
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.pick_up_and_courier_delivery">Pick up and courier delivery</ng-container>
								</li>
								<li>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
										<ng-container i18n="@@plan.accept_payments">Accept payments*</ng-container>
									</span>
									<a href="javascript:;" (click)="openPopup()" i18n="@@plan.learn_mores">Learn more</a>
								</li>
							</ul>
						</div>
						<!-- <a class="pricing_plans_card-footer" href="">
							<button>Start 30 Day Free Trial</button>
						</a> -->
						<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('yearly', 'online-store-basic')"
								[activePlan]="activePlan"
								[planType]="'online-store-basic'"
								[planFrequency]="'yearly'"
								[planAmount]="plans.yearly['online-store-basic'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
						<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('monthly', 'online-store-basic')"
								[activePlan]="activePlan"
								[planType]="'online-store-basic'"
								[planFrequency]="'monthly'"
								[planAmount]="plans.monthly['online-store-basic'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
					</div>
					<div *ngIf="currentTab === 'onlineStore'" class="pricing_plans_card">
						<div class="pricing_plans_card-header">
							<span class="plan-name" i18n="@@plan.online_store_pro">Online Store Pro</span>
							<span class="team-size" i18n="@@plan.three_team_member">3 team member</span>
						</div>
						<div class="pricing_plans_card-body">
							<div class="pricing_plans_card-body--header">
								<div *ngIf="activeTab == 'yearly'" class="card_price_block">
									<ng-container *ngIf="tempPlans?.yearly['online-store-pro']?.amount ; else noPrice">
										<div class="card_price_year">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-store-pro'].amount }}</span>
											<span i18n="@@plan.per_year">per year</span>
										</div>
										<div class="card_price_month">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-pro'].amount }}</span>
											<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-store-pro'].amount) }}</span>
											<span i18n="@@plan.per_month">per month</span>
										</div>
									</ng-container>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<div *ngIf="activeTab == 'monthly'" class="card_price_block">
									<div class="card_price_year" *ngIf="tempPlans?.monthly['online-store-pro']?.amount ; else noPrice">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-pro'].amount }}</span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
									<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
								</span>
							</div>
							<ul class="pricing_plans_card-body--body">
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.add_unlimited_items">Add unlimited items</ng-container>
								</li>
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.pick_up_and_courier_delivery">Pick up and courier delivery</ng-container>
								</li>
								<li>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
										<ng-container i18n="@@plan.accept_payments">Accept payments*</ng-container>
									</span>
									<a href="javascript:;" (click)="openPopup()" i18n="@@plan.learn_mores">Learn more</a>
								</li>
							</ul>
						</div>
						<!-- <a class="pricing_plans_card-footer" href="">
							<button>Start 30 Day Free Trial</button>
						</a> -->
						<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('yearly', 'online-store-pro')"
								[activePlan]="activePlan"
								[planType]="'online-store-pro'"
								[planFrequency]="'yearly'"
								[planAmount]="plans.yearly['online-store-pro'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
						<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('monthly', 'online-store-pro')"
								[activePlan]="activePlan"
								[planType]="'online-store-pro'"
								[planFrequency]="'monthly'"
								[planAmount]="plans.monthly['online-store-pro'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
					</div>
					<div *ngIf="currentTab === 'onlineStore'" class="pricing_plans_card">
						<div class="pricing_plans_card-header">
							<span class="plan-name" i18n="@@plan.online_store_enterprise">Online Store Enterprise</span>
							<span class="team-size" i18n="@@plan.ten_team_member">10 team member</span>
						</div>
						<div class="pricing_plans_card-body">
							<div class="pricing_plans_card-body--header">
								<div *ngIf="activeTab == 'yearly'" class="card_price_block">
									<ng-container *ngIf="tempPlans?.yearly['online-store-enterprise']?.amount ; else noPrice">
										<div class="card_price_year">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-store-enterprise'].amount }}</span>
											<span i18n="@@plan.per_year">per year</span>
										</div>
										<div class="card_price_month">
											<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-enterprise'].amount }}</span>
											<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-store-enterprise'].amount) }}</span>
											<span i18n="@@plan.per_month">per month</span>
										</div>
									</ng-container>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<div *ngIf="activeTab == 'monthly'" class="card_price_block">
									<div class="card_price_year" *ngIf="tempPlans?.monthly['online-store-enterprise']?.amount ; else noPrice">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-enterprise'].amount }}</span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
									<ng-template  #noPrice>
										<span class="spinner-grow text-muted"></span>
									</ng-template>
								</div>
								<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
									<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
								</span>
							</div>
							<ul class="pricing_plans_card-body--body">
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.add_unlimited_items">Add unlimited items</ng-container>
								</li>
								<li>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.pick_up_and_courier_delivery">Pick up and courier delivery</ng-container>
								</li>
								<li>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
											<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
											<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
										<ng-container i18n="@@plan.accept_payments">Accept payments*</ng-container>
									</span>
									<a href="javascript:;" (click)="openPopup()" i18n="@@plan.learn_mores">Learn more</a>
								</li>
							</ul>
						</div>
						<!-- <a class="pricing_plans_card-footer" href="">
							<button>Start 30 Day Free Trial</button>
						</a> -->
						<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('yearly', 'online-store-enterprise')"
								[activePlan]="activePlan"
								[planType]="'online-store-enterprise'"
								[planFrequency]="'yearly'"
								[planAmount]="plans.yearly['online-store-enterprise'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
						<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
							<subscription-plan-form
								class="w-100"
								[subscriptionBtn]="subscriptionBtn('monthly', 'online-store-enterprise')"
								[activePlan]="activePlan"
								[planType]="'online-store-enterprise'"
								[planFrequency]="'monthly'"
								[planAmount]="plans.monthly['online-store-enterprise'].amount"
								[userDetails]="userInfo"
								(onSubscribePlan)="onSubscribePlan($event)">
							</subscription-plan-form>
						</div>
					</div>
				</ng-template>


				<div *ngIf="currentTab === 'completeSolution'" class="pricing_plans_card completeSolution">
					<div class="pricing_plans_card-header">
						<span class="plan-name" i18n="@@plan.premium_teem_solution_for_all">The premium Teem solution for all your business needs and premium support from Teem to grow your business.</span>
						<span class="team-size" i18n="@@plan.twenty_team_member">20 team member</span>
						<img src="images/Badge.png" alt="spec_offer" loading="lazy">
					</div>
					<div class="pricing_plans_card-body">
						<div class="pricing_plans_card-body--header">
							<div *ngIf="activeTab == 'yearly'" class="card_price_block">
								<ng-container *ngIf="tempPlans?.yearly['complete-solution']?.amount ; else noPrice">
									<div class="card_price_year">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['complete-solution'].amount }}</span>
										<span i18n="@@plan.per_year">per year</span>
									</div>
									<div class="card_price_month">
										<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['complete-solution'].amount }}</span>
										<span class="discount-price"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['complete-solution'].amount) }}</span>
										<span i18n="@@plan.per_month">per month</span>
									</div>
								</ng-container>
								<ng-template  #noPrice>
									<span class="spinner-grow text-muted"></span>
								</ng-template>
							</div>
							<div *ngIf="activeTab == 'monthly'" class="card_price_block">
								<div class="card_price_year" *ngIf="tempPlans?.monthly['complete-solution']?.amount ; else noPrice">
									<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['complete-solution'].amount }}</span>
									<span i18n="@@plan.per_month">per month</span>
								</div>
								<ng-template  #noPrice>
									<span class="spinner-grow text-muted"></span>
								</ng-template>
							</div>
							<span *ngIf="activeTab == 'yearly'" class="discount_price_block">
								<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
							</span>
						</div>
						<ul class="pricing_plans_card-body--body">
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.invoice_enterprise">Invoice Enterprise</ng-container>
							</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.ecommerce_enteprise">Ecommerce Enteprise</ng-container>
							</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.marketing_promotions_influencer_campaigns">Marketing (Promotions, Influencer campaigns)</ng-container>
							</li>
							<li>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
									<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<ng-container i18n="@@plan.analytics">Analytics</ng-container>
							</li>
							<li>
								<span>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
										<path d="M7.9987 15.1654C8.87434 15.1664 9.74156 14.9945 10.5505 14.6594C11.3595 14.3243 12.0943 13.8326 12.7127 13.2127C13.3326 12.5943 13.8243 11.8595 14.1594 11.0505C14.4945 10.2416 14.6664 9.37434 14.6654 8.4987C14.6664 7.62307 14.4945 6.75585 14.1594 5.94687C13.8243 5.13789 13.3326 4.40309 12.7127 3.7847C12.0943 3.16476 11.3595 2.67311 10.5505 2.33801C9.74156 2.00291 8.87434 1.83096 7.9987 1.83204C7.12307 1.83096 6.25585 2.00291 5.44687 2.33801C4.63789 2.67311 3.90309 3.16476 3.2847 3.7847C2.66476 4.40309 2.17311 5.13789 1.83801 5.94687C1.50291 6.75585 1.33096 7.62307 1.33204 8.4987C1.33096 9.37434 1.50291 10.2416 1.83801 11.0505C2.17311 11.8595 2.66476 12.5943 3.2847 13.2127C3.90309 13.8326 4.63789 14.3243 5.44687 14.6594C6.25585 14.9945 7.12307 15.1664 7.9987 15.1654Z" stroke="#EB1461" stroke-width="1.5" stroke-linejoin="round" />
										<path d="M5.33203 8.5L7.33203 10.5L11.332 6.5" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<ng-container i18n="@@plan.premium_support">Premium support</ng-container>
								</span>
							</li>
						</ul>
					</div>
					<!-- <a class="pricing_plans_card-footer" href="">
						<button>Start 30 Day Free Trial</button>
					</a> -->
					<div *ngIf="activeTab == 'yearly'" class="card_price_block w-100">
						<subscription-plan-form
							class="w-100"
							[subscriptionBtn]="subscriptionBtn('yearly', 'complete-solution')"
							[activePlan]="activePlan"
							[planType]="'complete-solution'"
							[planFrequency]="'yearly'"
							[planAmount]="plans.yearly['complete-solution'].amount"
							[userDetails]="userInfo"
							(onSubscribePlan)="onSubscribePlan($event)">
						</subscription-plan-form>
					</div>
					<div *ngIf="activeTab == 'monthly'" class="card_price_block w-100">
						<subscription-plan-form
							class="w-100"
							[subscriptionBtn]="subscriptionBtn('monthly', 'complete-solution')"
							[activePlan]="activePlan"
							[planType]="'complete-solution'"
							[planFrequency]="'monthly'"
							[planAmount]="plans.monthly['complete-solution'].amount"
							[userDetails]="userInfo"
							(onSubscribePlan)="onSubscribePlan($event)">
						</subscription-plan-form>
					</div>
				</div>
			</div>

			<div class="pricing_plans_table-container">
				<h3 i18n="@@plan.compare_features">Compare Features</h3>
				<table class="pricing_plans_table">
					<thead>
						<tr *ngIf="currentTab === 'invoicing'">
							<th></th>
							<th i18n="@@plan.invoice_basic">Invoice Basic</th>
							<th i18n="@@plan.invoice_pro">Invoice Pro</th>
							<th i18n="@@plan.invoice_enterprise">Invoice Enterprise</th>
						</tr>
						<tr *ngIf="currentTab === 'onlineStore'">
							<th></th>
							<th i18n="@@plan.online_store_basic">Online Store Basic</th>
							<th i18n="@@plan.online_store_pro">Online Store Pro</th>
							<th i18n="@@plan.online_store_enterprise">Online Store Enterprise</th>
						</tr>
						<tr *ngIf="currentTab === 'onlineOrdering'">
							<th></th>
							<th i18n="@@plan.online_ordering_basic">Online Ordering Basic</th>
							<th i18n="@@plan.online_ordering_pro">Online Ordering Pro</th>
							<th i18n="@@plan.online_ordering_enterprise">Online Ordering Enterprise</th>
						</tr>
						<tr *ngIf="currentTab === 'completeSolution'">
							<th></th>
							<th i18n="@@plan.invoice_enterprise">Invoicing Enterprise</th>
							<th i18n="@@plan.invoice_enterprise">Invoicing Enterprise</th>
							<th i18n="@@plan.teem_complete_solution">Teem Complete Solution</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngIf="activeTab == 'yearly'">
							<td i18n="@@plan.price_year">Price/year</td>
							<td>
								<div class="pricing_plans_card-body--header pb-0 border-0">
									<div class="card_price_block">
										<div class="card_price_year">
											<span *ngIf="currentTab === 'invoicing'" class="fs-5 fw-semibold">
												<ng-container *ngIf="tempPlans?.yearly['invoice-basic']?.amount ; else noPrice">
													<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['invoice-basic'].amount }}</span>
												</ng-container>
												<ng-template  #noPrice>
													<span class="spinner-grow text-muted"></span>
												</ng-template>
											</span>
											<span *ngIf="currentTab === 'onlineStore'" class="fs-5 fw-semibold">
												<ng-container *ngIf="tempPlans?.yearly['online-store-basic']?.amount ; else noPrice">
													<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-store-basic'].amount }}</span>
												</ng-container>
												<ng-template  #noPrice>
													<span class="spinner-grow text-muted"></span>
												</ng-template>
											</span>
											<span *ngIf="currentTab === 'completeSolution'" class="fs-5 fw-semibold">
												<ng-container *ngIf="tempPlans?.yearly['invoice-enterprise']?.amount ; else noPrice">
													<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['invoice-enterprise'].amount }}</span>
												</ng-container>
												<ng-template  #noPrice>
													<span class="spinner-grow text-muted"></span>
												</ng-template>
											</span>
										</div>
									</div>
									<span class="discount_price_block">
										<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
									</span>
								</div>
							</td>
							<td>
								<div class="pricing_plans_card-body--header pb-0 border-0">
									<div class="card_price_block">
										<div class="card_price_year">
											<span *ngIf="currentTab === 'invoicing'" class="fs-5 fw-semibold">
												<ng-container *ngIf="tempPlans?.yearly['invoice-pro']?.amount ; else noPrice">
													<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['invoice-pro'].amount }}</span>
												</ng-container>
												<ng-template  #noPrice>
													<span class="spinner-grow text-muted"></span>
												</ng-template>
											</span>
											<span *ngIf="currentTab === 'onlineStore'" class="fs-5 fw-semibold">
												<ng-container *ngIf="tempPlans?.yearly['online-store-pro']?.amount ; else noPrice">
													<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-store-pro'].amount }}</span>
												</ng-container>
												<ng-template  #noPrice>
													<span class="spinner-grow text-muted"></span>
												</ng-template>
											</span>
											<span *ngIf="currentTab === 'completeSolution'" class="fs-5 fw-semibold">
												<ng-container *ngIf="tempPlans?.yearly['online-store-enterprise']?.amount ; else noPrice">
													<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-store-enterprise'].amount }}</span>
												</ng-container>
												<ng-template  #noPrice>
													<span class="spinner-grow text-muted"></span>
												</ng-template>
											</span>
										</div>
									</div>
									<span class="discount_price_block">
										<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
									</span>
								</div>
							</td>
							<td>
								<div class="pricing_plans_card-body--header pb-0 border-0">
									<div class="card_price_block">
										<div class="card_price_year">
											<span *ngIf="currentTab === 'invoicing'" class="fs-5 fw-semibold">
												<ng-container *ngIf="tempPlans?.yearly['invoice-enterprise']?.amount ; else noPrice">
													<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['invoice-enterprise'].amount }}</span>
												</ng-container>
												<ng-template  #noPrice>
													<span class="spinner-grow text-muted"></span>
												</ng-template>
											</span>
											<span *ngIf="currentTab === 'onlineStore'" class="fs-5 fw-semibold">
												<ng-container *ngIf="tempPlans?.yearly['online-store-enterprise']?.amount ; else noPrice">
													<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['online-store-enterprise'].amount }}</span>
												</ng-container>
												<ng-template  #noPrice>
													<span class="spinner-grow text-muted"></span>
												</ng-template>
											</span>
											<span *ngIf="currentTab === 'completeSolution'" class="fs-5 fw-semibold">
												<ng-container *ngIf="tempPlans?.yearly['complete-solution']?.amount ; else noPrice">
													<span><span [innerHtml]="planCurrency"></span> {{ tempPlans.yearly['complete-solution'].amount }}</span>
												</ng-container>
												<ng-template  #noPrice>
													<span class="spinner-grow text-muted"></span>
												</ng-template>
											</span>
										</div>
									</div>
									<span class="discount_price_block">
										<ng-container i18n="@@plan.plan_discount">-{{ discountPer }}% discount</ng-container>
									</span>
								</div>
							</td>
						</tr>

						<tr>
							<td i18n="@@plan.price_year">Price/month</td>
							<td>
								<div class="pricing_plans_card-body--header pb-0 border-0">
									<div *ngIf="currentTab === 'invoicing'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-basic'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['invoice-basic'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-basic'].amount }}</span>
										</div>
									</div>
									<div *ngIf="currentTab === 'onlineStore'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-basic'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-store-basic'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-basic'].amount }}</span>
										</div>
									</div>
									<div *ngIf="currentTab === 'onlineOrdering'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-basic'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-ordering-basic'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-basic'].amount }}</span>
										</div>
									</div>
									<div *ngIf="currentTab === 'completeSolution'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-enterprise'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['invoice-enterprise'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-enterprise'].amount }}</span>
										</div>
									</div>
								</div>
							</td>
							<td>
								<div class="pricing_plans_card-body--header pb-0 border-0">
									<div *ngIf="currentTab === 'invoicing'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-pro'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['invoice-pro'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-pro'].amount }}</span>
										</div>
									</div>
									<div *ngIf="currentTab === 'onlineStore'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-pro'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-store-pro'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-pro'].amount }}</span>
										</div>
									</div>
									<div *ngIf="currentTab === 'onlineOrdering'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-pro'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-ordering-pro'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-pro'].amount }}</span>
										</div>
									</div>
									<div *ngIf="currentTab === 'completeSolution'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-enterprise'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-store-enterprise'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-enterprise'].amount }}</span>
										</div>
									</div>
								</div>
							</td>
							<td>
								<div class="pricing_plans_card-body--header pb-0 border-0">
									<div *ngIf="currentTab === 'invoicing'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-enterprise'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['invoice-enterprise'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['invoice-enterprise'].amount }}</span>
										</div>
									</div>
									<div *ngIf="currentTab === 'onlineStore'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-enterprise'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-store-enterprise'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-store-enterprise'].amount }}</span>
										</div>
									</div>
									<div *ngIf="currentTab === 'onlineOrdering'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-enterprise'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['online-ordering-enterprise'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['online-ordering-enterprise'].amount }}</span>
										</div>
									</div>
									<div *ngIf="currentTab === 'completeSolution'" class="card_price_block">
										<div *ngIf="activeTab == 'yearly'" class="card_price_month">
											<span class="d-none"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['complete-solution'].amount }}</span>
											<span class="fw-semibold"><span [innerHtml]="planCurrency"></span> {{ discountedPlanAmount(tempPlans.monthly['complete-solution'].amount) }}</span>
											<span class="d-none">per month</span>
										</div>
										<div *ngIf="activeTab == 'monthly'" class="card_price_year">
											<span class="fs-5 fw-semibold"><span [innerHtml]="planCurrency"></span> {{ tempPlans.monthly['complete-solution'].amount }}</span>
										</div>
									</div>
								</div>
							</td>

						</tr>

						<tr *ngIf="currentTab === 'invoicing'">
							<td i18n="@@plan.invoices_per_month">Invoices per month</td>
							<td>10</td>
							<td>100</td>
							<td i18n="@@plan.unlimited">Unlimited</td>
						</tr>

						<tr *ngIf="currentTab != 'completeSolution'" class="section-header">
							<td colspan="4" i18n="@@plan.invoicing_features">Invoicing Features</td>
						</tr>

						<tr *ngIf="currentTab === 'completeSolution'" class="section-header">
							<td colspan="4" i18n="@@plan.online_store_features">Online Store Features</td>
						</tr>

						<ng-container *ngIf="currentTab != 'completeSolution'">
							<tr *ngFor="let feature of invoicingFeatures">
								<td>{{ feature.name }}</td>
								<td><span [class.icon-check]="feature.basic">{{ feature.basic ? '✔' : '' }}</span></td>
								<td><span [class.icon-check]="feature.pro">{{ feature.pro ? '✔' : '' }}</span></td>
								<td><span [class.icon-check]="feature.enterprise">{{ feature.enterprise ? '✔' : '' }}</span></td>
							</tr>
						</ng-container>

						<ng-container *ngIf="currentTab === 'completeSolution'">
							<tr *ngFor="let feature of completeSolutionFeatures">
								<td>{{ feature.name }}</td>
								<td><span [class.icon-check]="feature.basic">{{ feature.basic ? '✔' : '' }}</span></td>
								<td><span [class.icon-check]="feature.pro">{{ feature.pro ? '✔' : '' }}</span></td>
								<td><span [class.icon-check]="feature.enterprise">{{ feature.enterprise ? '✔' : '' }}</span></td>
							</tr>
						</ng-container>

						<tr *ngIf="currentTab === 'completeSolution'" class="section-header">
							<td colspan="4" i18n="@@plan.invoicing_features">Invoicing Features</td>
						</tr>

						<tr *ngIf="currentTab === 'completeSolution'">
							<td i18n="@@plan.invoices_per_month">Invoices per month</td>
							<td i18n="@@plan.unlimited">Unlimited</td>
							<td i18n="@@plan.unlimited">Unlimited</td>
							<td i18n="@@plan.unlimited">Unlimited</td>
						</tr>

						<ng-container *ngIf="currentTab === 'completeSolution'">
							<tr *ngFor="let feature of invoicingFeatures">
								<td>{{ feature.name }}</td>
								<td><span [class.icon-check]="feature.basic">{{ feature.basic ? '✔' : '' }}</span></td>
								<td><span [class.icon-check]="feature.pro">{{ feature.pro ? '✔' : '' }}</span></td>
								<td><span [class.icon-check]="feature.enterprise">{{ feature.enterprise ? '✔' : '' }}</span></td>
							</tr>
						</ng-container>

						<tr class="section-header">
							<td colspan="4" i18n="@@plan.other">Other</td>
						</tr>

						<tr *ngFor="let feature of otherFeatures">
							<td>{{ feature.name }}</td>
							<td><span [class.icon-check]="feature.basic">{{ feature.basic ? '✔' : '' }}</span></td>
							<td><span [class.icon-check]="feature.pro">{{ feature.pro ? '✔' : '' }}</span></td>
							<td><span [class.icon-check]="feature.enterprise">{{ feature.enterprise ? '✔' : '' }}</span></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
<!-- <new-activation-list></new-activation-list> -->
